<template>
  <nav class="menu-button">
    <header class="menu-header">
      {{ $t('menu') }}
      <arrow-right class="close-icon" @click="$emit('close')"></arrow-right>
    </header>
    <div class="button-container">
      <button
        v-for="menuItem in menuItems"
        :key="menuItem.uuid"
        class="btn-item"
        type="button"
        @click="$emit('menu-click', menuItem)"
      >
        <component :is="menuIconMap[menuItem.action]" class="menu__icon"></component>
        <span
          v-if="menuItem.shared_content_component.icon_type === componentIconType.MATERIAL_ICON"
          class="material-symbols-outlined filled"
          :data-cy="
            `menu-item-material-icon-${menuItem.action}` +
            (menuItem.shared_content_component.uuid
              ? `-${menuItem.shared_content_component.uuid}`
              : '')
          "
          v-html="menuItem.shared_content_component.icon"
        ></span>
        <img
          v-else-if="
            menuItem.shared_content_component.icon_type === componentIconType.CUSTOM &&
            menuItem.shared_content_component.icon_image
          "
          class="custom-icon"
          :src="menuItem.shared_content_component.icon_image.thumbnail"
          alt="icon"
          :data-cy="
            `menu-item-custom-icon-${menuItem.action}` +
            (menuItem.shared_content_component.uuid
              ? `-${menuItem.shared_content_component.uuid}`
              : '')
          "
        />
        {{ menuItem.text }}
      </button>
      <p class="link-container">
        <a class="link" rel="noopener noreferrer" :href="termsOfUseLink" target="_blank">{{
          $t('terms_of_use')
        }}</a>
        <a class="link" rel="noopener noreferrer" :href="privacyPolicyLink" target="_blank">{{
          $t('privacy_policy')
        }}</a>
      </p>
    </div>
  </nav>
</template>

<script>
import chatMenuMixin from './chatMenuMixin'
import ArrowRight from 'assets/icons/chevron-right.svg?inline'

export default {
  components: {
    ArrowRight
  },
  mixins: [chatMenuMixin]
}
</script>
